import { MarketFileUploadCustomEvent } from '@market/web-components';
import { ApiReferenceTypeText } from '@squareup/dex-ui-shared-api-reference';
import { MarketFileUpload } from '@squareup/dex-ui-shared-market';
import clsx from 'clsx';
import React, { FC, memo, useCallback } from 'react';

import { ApiExplorerFieldLabel } from './ApiExplorerFieldLabel';
import styles from './api-explorer-field.module.css';
import { ApiExplorerFieldProps } from './props';

const strings = {
  fieldName: 'file',
  fieldType: 'binary',
};

interface Props extends Omit<ApiExplorerFieldProps, 'property'> {}

const ApiExplorerFileField: FC<Props> = memo(({ onChange, path }) => {
  const onFileUpload = useCallback(
    (e: MarketFileUploadCustomEvent<{ value: Array<File> }>) => {
      const file = e.detail.value?.[0];
      onChange(file, `${path}/file`);
    },
    [onChange, path]
  );

  return (
    <>
      <ApiExplorerFieldLabel
        name={strings.fieldName}
        typeField={
          <ApiReferenceTypeText>{strings.fieldType}</ApiReferenceTypeText>
        }
      />
      <MarketFileUpload
        className={clsx(styles.file)}
        onMarketFileUploadValueChange={onFileUpload}
      />
    </>
  );
});

ApiExplorerFileField.displayName = 'ApiExplorerFileField';

export { ApiExplorerFileField };
